import { Row, Button, IconButton } from '@fs/zion-ui'
import { TreePedigree, TreeViewRelationship, SocialStar } from '@fs/zion-icon'
import { css } from '@emotion/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

const marginOverrideCss = css`
  & button,
  a {
    margin: 0;
  }
`

type Props = {
  hideText?: boolean
}

export default function BannerActionsSkeleton({ hideText }: Props): JSX.Element {
  const [t] = useTranslation()
  const viewTreeLabel = t('tree-person.view-tree.action')
  const viewRelationshipLabel = t('tree-person.view-relationship.action')
  const followLabel = t('tree-person.follow.action')

  return (
    <div css={marginOverrideCss}>
      <Row wrap alignY="middle" guttersY="nano" guttersX="xxs">
        {hideText ? (
          <IconButton
            data-testid="view-tree-button"
            Icon={TreePedigree}
            title={viewTreeLabel}
            emphasis="low"
            disabled
          />
        ) : (
          <Button data-testid="view-tree-button" Icon={TreePedigree} emphasis="low" disabled>
            {viewTreeLabel}
          </Button>
        )}
        {hideText ? (
          <IconButton
            data-testid="relationship-viewer-button"
            Icon={TreeViewRelationship}
            title={viewRelationshipLabel}
            emphasis="low"
            disabled
          />
        ) : (
          <Button data-testid="relationship-viewer-button" Icon={TreeViewRelationship} emphasis="low" disabled>
            {viewRelationshipLabel}
          </Button>
        )}
        {hideText ? (
          // eslint-disable-next-line test-selectors/button -- skeleton placeholder
          <IconButton Icon={SocialStar} title={followLabel} emphasis="low" disabled />
        ) : (
          // eslint-disable-next-line test-selectors/button -- skeleton placeholder
          <Button Icon={SocialStar} emphasis="low" disabled>
            {followLabel}
          </Button>
        )}
      </Row>
    </div>
  )
}
